import { writable } from 'svelte/store';
export const explorerState = writable({
    context : "load",
    rootDir : "personal", // Can now be "personal", "team", "recent", or "starred"
    records : [],
    selectedRecords : [],
    navHistory : [],
    view : "table"
});